<template>
  <Modal 
    :id="'cmp-invoice-reminder-add-modal'" 
    @cancelled="onCancel"
  >
    <template slot="header">New {{$t('reminder')}} </template>
    <template slot="body">
      <div class="form-group">
        <div class="ut-flex">
            <TextField
                class="m1"
                :id="'date'"
                type="date"
                style="min-width:120px"
                required
                v-bind="textFieldConfig"
                :showValidationIcons="true"
                :immediateValidation="true"
                :value="date"
                :placeholder="$t('date')"
                @valuechanged="onTextFieldValueChange"
                @validated="onValidation"
            />
            <TextField
                class="m1"
                :id="'account_check_date'"
                type="date"
                style="min-width:120px;margin-left:50px !important"
                required
                v-bind="textFieldConfig"
                :showValidationIcons="true"
                :immediateValidation="true"
                :value="account_check_date"
                :placeholder="$t('account_check_date')"
                @valuechanged="onTextFieldValueChange"
                @validated="onValidation"
            />
        </div> 
        <TextField
          class="m1"
          :id="'subject'"
          v-bind="textFieldConfig"
          :value="subject"
          :placeholder="$t('subject')"
          @valuechanged="onTextFieldValueChange"
          
        />     
        <DTCheckbox
          :id="'barcode_catalog_error'"
          :label="$t('exclude_cost')"
          :checked="exclude_cost"
          @click="onCheckCliked"
          :minH="'42px'"
          :class="'ml0'"
        />
        <SearchList
            :id="'invoice_project_list'"
            :items="invoiceProjectList"
            :keyProperty="'invoice_project_id'"
            :label="'invoice_project_name'"
            :placeholder="'Search Invoice Project'"
            :isSearchable="false"
              @selected="onInvoiceProjectSelected"
           
        />
      </div>
    </template>
    <template slot="options">
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >
       {{$t('cancel')}}
      </button>
      <button
        class="dt-button v1 with-ico"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="addNewInvoiceReminder"
      >
        {{$t('ok')}}
      </button>

    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';
import SearchList from "@dtplugins/search-list/search-list";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
import { format } from "date-fns";
import { InvoiceReminderService } from '../../services/invoice-reminder.service';
export default {
  components: {
    Modal,
    SearchList,
    DTCheckbox
  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },
        
      date:format(new Date(), "YYYY-MM-DD"),
      account_check_date:format(new Date(), "YYYY-MM-DD"),
      subject:'',
      exclude_cost:'',
      selectedInvoiceProject: new Set(),
      invoiceProjectList:[],
      validationResult: {},
    };
  },
  mounted:async function() {
      const resData= await InvoiceReminderService.modalNewInvoiceReminder();
      console.log(resData);
      this.invoiceProjectList=resData.data.invoice_projects
  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
    licenceStatusesTV:function(params) {
      return createTV(this.licenceStatuses,"licence_status_text","licence_status_id");
    },

  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onInvoiceProjectSelected:function(selectedInvoiceProject){
        this.selectedInvoiceProject=selectedInvoiceProject
        console.log(this.selectedInvoiceProject)
    },
    onCheckCliked:function(event){
        if(event.target.checked){
            this.exclude_cost='yes'
        }else{
            this.exclude_cost='no'
        }
        
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this[key]=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    addNewInvoiceReminder: async function(e) {
      console.log()
      this.$emit('create', {date:this.date ,account_check_date:this.account_check_date, exclude_cost:this.exclude_cost, subject:this.subject ,invoice_project_list:Array.from( this.selectedInvoiceProject)});
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-invoice-reminder-add-modal {
}
</style>